import { useQuery } from "@tanstack/react-query";
import { SELECTS_KEY } from "constants/TanStackKeys";
import { getSelectOptions } from "services/api/form";

export const useSelectOptionsQuery = () => {
  return useQuery({
    queryKey: [SELECTS_KEY],
    queryFn: () => getSelectOptions(),
    retry: false,
  });
};

